<app-dialog
  headerGlyph="trash"
  [headerText]="title"
  saveText="Go to RTD Type Resources"
  [showTopCancelButton]="false"
  cancelText="Close"
  [body]="body"
  (save)="onGoToResources()"
  [validationFn]="validate.bind(this)"
>
  <ng-template #body>
    @if (!loading) {
      <div class="container">
        <div>
          We couldn't delete the folder because it contains a managed service
          with instances of the type defined in its RTD, that are located
          outside of this folder.
          <br /><br />
          To resolve this issue, please do the following:
          <ol>
            <li>
              Open the details of the managed service within the folder and go
              to the
              <span class="link-color" (click)="onGoToResources()"
                >RTD Type Resources</span
              >
              tab.
            </li>
            <li>
              Locate the paths of all the instances of the type and manually
              delete them.
            </li>
            <li>
              Once the instances have been deleted, come back and delete this
              folder with its remaining contents.
            </li>
          </ol>
        </div>
        <app-constraint-notification
          [resource]="resource"
          type="delete"
        ></app-constraint-notification>
        @if (!!errorMsg) {
          <app-error-strip
            [errorText]="FAILED_MSGS[resource.type] || 'Cannot delete resource'"
            [errorMsg]="errorMsg"
          ></app-error-strip>
        }
      </div>
    }
  </ng-template>
</app-dialog>
